import { Link } from "react-router-dom";
import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";

const services = [
  {
    no: "01",
    title: "Consultation",
    body: "We work alongside you and your designer to select the right materials for your space — on site or remotely.",
  },
  {
    no: "02",
    title: "Supply & Delivery",
    body: "From samples to final order, we manage sourcing and logistics so everything arrives when and where you need it.",
  },
  {
    no: "03",
    title: "Installation",
    body: "Our trusted network of installers ensures every material is fitted with precision and care.",
  },
  {
    no: "04",
    title: "Aftercare",
    body: "Guidance on maintenance and care so your surfaces continue to look their best for decades to come.",
  },
];

export default function Services() {
  return (
    <>
      <PageHead
        eyebrow="Services"
        titleLines={["How we", "work with you."]}
      />

      <section className="hairline bg-secondary/40" data-testid="services-grid">
        <div className="edge grid grid-cols-1 gap-16 py-24 md:grid-cols-12 md:py-32">
          <div className="md:col-span-4">
            <span className="eyebrow">Our Services</span>
            <h2 className="mt-6 text-4xl font-light leading-tight tracking-editorial md:text-5xl">
              From concept to care.
            </h2>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted-foreground">
              We support your project at every stage — helping you choose,
              source, install and maintain materials made to last a lifetime.
            </p>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <div className="divide-y hairline">
              {services.map((s, i) => (
                <Reveal key={s.no} delay={i * 0.22}>
                  <div className="grid grid-cols-12 gap-4 py-8" data-testid={`service-card-${s.no}`}>
                    <span className="col-span-2 eyebrow pt-1">{s.no}</span>
                    <h3 className="col-span-10 text-2xl font-light tracking-editorial md:col-span-4">
                      {s.title}
                    </h3>
                    <p className="col-span-12 text-sm leading-relaxed text-muted-foreground md:col-span-6">
                      {s.body}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="edge hairline py-24 text-center md:py-32" data-testid="services-enquire">
        <p className="mx-auto max-w-xl text-2xl font-light tracking-editorial md:text-3xl">
          Discuss your project with our team.
        </p>
        <Link
          to="/contact"
          data-testid="services-enquire-cta"
          className="mt-8 inline-block border-b border-foreground pb-1 text-sm uppercase tracking-[0.16em]"
        >
          Book a consultation →
        </Link>
      </section>
    </>
  );
}
